import {Badge, Paper, Stack, Text} from '@mantine/core'

import {formatBusinessTimestamp} from 'src/api/business-time'
import type {EquipmentCurrentStatus} from 'src/equipment-deployment/schemas'
import {deploymentStatusColor} from 'src/theme/semantic-colors'

type EquipmentDeploymentStatusSectionProps = {
    currentStatus: EquipmentCurrentStatus
}

function formatDeploymentTimestamp(timestamp: string) {
    return formatBusinessTimestamp(timestamp, 'MMM d, yyyy · h:mm a')
}

export function EquipmentDeploymentStatusSection({
    currentStatus,
}: EquipmentDeploymentStatusSectionProps) {
    return (
        <Paper withBorder p="md" radius="md">
            <Text fw={600} mb="xs">
                Deployment status
            </Text>
            {currentStatus.status === 'available' ? (
                <Stack gap={4}>
                    <Badge color={deploymentStatusColor('available')} variant="light">
                        Not deployed
                    </Badge>
                    <Text size="sm" c="dimmed">
                        Physical location in the field — separate from job bookings.
                    </Text>
                </Stack>
            ) : currentStatus.status === 'deployed' ? (
                <Stack gap={4}>
                    <Badge color={deploymentStatusColor('deployed')} variant="light">
                        Deployed
                    </Badge>
                    {currentStatus.locationLabel ? (
                        <Text size="sm">At {currentStatus.locationLabel}</Text>
                    ) : null}
                    {currentStatus.timestamp ? (
                        <Text size="sm" c="dimmed">
                            Since {formatDeploymentTimestamp(currentStatus.timestamp)}
                        </Text>
                    ) : null}
                </Stack>
            ) : (
                <Stack gap={4}>
                    <Badge
                        color={deploymentStatusColor(
                            currentStatus.status === 'picked_up' ? 'picked_up' : 'dispatched',
                        )}
                        variant="light"
                    >
                        {currentStatus.status === 'picked_up' ? 'Picked up' : 'Dispatched'}
                    </Badge>
                    {currentStatus.locationLabel ? (
                        <Text size="sm">{currentStatus.locationLabel}</Text>
                    ) : null}
                    {currentStatus.timestamp ? (
                        <Text size="sm" c="dimmed">
                            {formatDeploymentTimestamp(currentStatus.timestamp)}
                        </Text>
                    ) : null}
                </Stack>
            )}
        </Paper>
    )
}
